import type { GuideSourceDetails } from "@expert/solve-tools/src/guides/types";

import { isGuideSupported } from "@expert/solve-tools";

import { INSTALLATION_INTENT } from "./types";

interface OpenInstallationGuideProps {
    isGuideOpen: boolean;
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isCustomerVerificationComplete: boolean;
    isLoadingSimplrSession: boolean;
    intent?: string;
}
export function shouldOpenInstallationGuide({
    disableAutomaticOpen,
    intent,
    isCustomerSession,
    isCustomerVerificationComplete,
    isGuideOpen,
    isLoadingSimplrSession,
}: Readonly<OpenInstallationGuideProps>): { shouldOpenGuide: boolean; sourceDetails: GuideSourceDetails } {
    const isInstallationGuideSupported = isGuideSupported("Installation");
    const shouldOpenGuide =
        intent === INSTALLATION_INTENT &&
        isInstallationGuideSupported &&
        !isGuideOpen &&
        isCustomerSession &&
        isCustomerVerificationComplete &&
        !disableAutomaticOpen &&
        !isLoadingSimplrSession;
    return { shouldOpenGuide, sourceDetails: "intent" };
}
